import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PromotionSetting2HttpService {

  constructor(private http: HttpClient) { }
}
